import groupBy from "lodash.groupby";

const prepareFilters = filters => {
  const filtersByType = groupBy(filters, "type");

  return [
    "author",
    "brand",
    "origin",
    "isOpenForComment",
    "isPromoted",
    "label",
    "created",
    "updated",
    "permissionGroup",
    "userSegment",
    "category",
    "section",
  ].reduce(
    (result, key) => ({
      ...result,
      [key]: (filtersByType[key] || []).map(({ value }) => value),
    }),
    {}
  );
};

export default prepareFilters;



// WEBPACK FOOTER //
// ./src/utils/prepareFilters.js